import type { Block, BlockType, BlockContent, BlockSettings } from '@mawkaa/types';
import { blockRegistry } from './registry';

export function createBlock(type: BlockType, order: number = 0): Block {
  const definition = blockRegistry[type];
  if (!definition) {
    throw new Error(`Unknown block type: ${type}`);
  }

  return {
    id: generateBlockId(),
    type,
    content: { ...definition.defaultContent } as BlockContent,
    settings: { ...definition.defaultSettings },
    order,
  };
}

export function duplicateBlock(block: Block): Block {
  return {
    ...block,
    id: generateBlockId(),
    content: JSON.parse(JSON.stringify(block.content)),
    settings: JSON.parse(JSON.stringify(block.settings)),
  };
}

export function moveBlock(blocks: Block[], fromIndex: number, toIndex: number): Block[] {
  const result = [...blocks];
  const [removed] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, removed);

  // Update order property
  return result.map((block, index) => ({
    ...block,
    order: index,
  }));
}

export function updateBlockContent<T extends BlockContent>(
  block: Block,
  updates: Partial<T>
): Block {
  return {
    ...block,
    content: {
      ...block.content,
      ...updates,
    } as BlockContent,
  };
}

export function updateBlockSettings(
  block: Block,
  updates: Partial<BlockSettings>
): Block {
  return {
    ...block,
    settings: {
      ...block.settings,
      ...updates,
    },
  };
}

function generateBlockId(): string {
  return `block_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
}
